import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { DriverShell } from "../driver/DriverShell";

export function DriverProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-primary" data-testid="driver-auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/driver/login" state={{ from: location }} replace />;
  }

  if (user.role !== "driver") {
    return <Navigate to={user.role === "customer" ? "/customer" : "/"} replace />;
  }

  return <DriverShell>{children}</DriverShell>;
}
